import React, { useState, useRef, useEffect } from "react";

const FooterDescription: React.FC = () => {
  const [open, setOpen] = useState(false);

  const ref = useRef<HTMLSpanElement | null>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (
        ref.current &&
        e.target instanceof Node &&
        !ref.current.contains(e.target)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <span className="footer-tooltip" ref={ref}>
      <i
        className="fa-solid fa-circle-info"
        role="button"
        onClick={() => setOpen(!open)}
      ></i>

      {open && (
        <div className="tooltip-box">
          <strong>Disclaimer:</strong> Images are both human and AI generated.
          <br />
          <strong>Credit:</strong> Powered by Sciever Inc Pvt. Ltd.
        </div>
      )}
    </span>
  );
};

export default FooterDescription;
